// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://api.stratos-dining-zons.de/api/', // 'http://localhost:8000/api/', // 
  BASE_URL: 'https://api.stratos-dining-zons.de', // 'http://localhost:8000',// 
  DEFAULT_LANG: 'de',
  APP_VERSION: '0.2', // change app version to force clear cache
  GOOGLE_COUNTRIES: ["de"], // for google address
  GOOGLE_LOGIN_WEB_CLIENT_ID: '1029643976897-m3r3t1t376m3m71o1caf5j62a1bo7qbg.apps.googleusercontent.com',
  FACEBOOK_LOGIN_APP_ID: '787613765618676',
  // theme configuration
  DEFAULT_PRIMARY_COLOR: '#b4304b',
  DEFAULT_PRIMARY_TEXT_COLOR: '#b4304b'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
